import SelectionArea from "@simonwep/selection-js";

const selection = new SelectionArea({
    class: "selectable-item",
    selectables: [".selectable-item"],
    startareas: ["#selectable"],
    boundaries: ["#selectable"],
    singleTap: {
        allow: true,
        intersect: "native",
    },
})
.on(
    "move",
    ({
        store: {
            changed: { added, removed },
        },
    }) => {
        console.log(removed);

        // Add a custom class to the elements that where selected.
        for (const el of added) {
            el.classList.add("bg-success-o-30");
            el.classList.add("rounded");
            el.classList.add("font-weight-bold");

            const list = el.getElementsByTagName("input");
            for (let item of list) {
                item.checked = true;
            }
        }

        // Remove the class from elements that where removed
        // since the last selection
        for (const el of removed) {
            el.classList.remove("bg-success-o-30");
            el.classList.remove("rounded");
            el.classList.remove("font-weight-bold");

            const list = el.getElementsByTagName("input");
            for (let item of list) {
                item.checked = false;
            }
        }
    }
)
.on("stop", () => {
    selection.keepSelection();
});
